import React, { useEffect, useState } from "react";
import UserItem from "./UserItem";
import CreateUserForm from "./CreateUserForm";
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers, addUser, deleteUser, updateUser } from '../reduxStore/slices/userSlice';
import { logout } from '../reduxStore/slices/authSlice';
import { useNavigate } from 'react-router-dom';
import EditUserModal from "./EditUserModal";

const AdminPanel = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const users = useSelector(state => state.userReducer.list);
  const status = useSelector(state => state.userReducer.status);
  const [newUser, setNewUser] = useState({ name: '', email: '', role: '', password: '' });
  const [userToRemove, setUserToRemove] = useState(null);
  const errorMessage = useSelector(state => state.userReducer.errorMessage);
  const [editingUser, setEditingUser] = useState(null);
  const [sortingColumn, setSortingColumn] = useState('id');
  const [sortingOrder, setSortingOrder] = useState('asc');

  const handleEditUser = (user) => setEditingUser(user);

  const handleSaveEditUser = (user) => {
    dispatch(updateUser({ id: user.id, data: user }));
    setEditingUser(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login', { replace: true });
  };

  useEffect(() => {
    dispatch(fetchUsers({ sortingColumn, sortingOrder }));
  }, [dispatch, sortingColumn, sortingOrder]);

  if (status === 'loading') return <p>Loading users...</p>;
  if (status === 'failed') return <p>Failed to load users.</p>;

  const handleAddUser = (e) => {
    e.preventDefault();
    if (newUser.name && newUser.email) {
      dispatch(addUser(newUser));
      setNewUser({ name: '', email: '', role: '', password: '' });
    }
  };

  const removeUser = (userId) => {
    dispatch(deleteUser(userId));
    setUserToRemove(null);
  };

  const handleDeleteUser = (user) => {
    setUserToRemove(user);
  };

  const setSorting = (column) => {
    if (sortingColumn === column) {
      setSortingOrder(sortingOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortingColumn(column);
      setSortingOrder('asc');
    }
  }

  const getSortArrow = (column) => {
    if (sortingColumn === column) {
      return <span style={{fontSize: 12}}>{sortingOrder === 'asc' ? '▲' : '▼'}</span>;
    }
    return '';
  }

  return (
    <div style={{ padding: '30px', fontFamily: 'Arial, sans-serif', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ textAlign: 'center', color: '#333' }}>Admin Panel</h2>
      <button
        onClick={handleLogout}
        style={{ position: 'absolute', top: '30px', right: '30px', padding: '8px 16px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
      >
        Logout
      </button>

      <CreateUserForm setNewUser={setNewUser} handleAddUser={handleAddUser} newUser={newUser} />

      {errorMessage && (
        <div style={{ color: 'red', textAlign: 'center', marginBottom: 10 }}>
          {errorMessage}
        </div>
      )}

      <table style={{ width: '100%', borderCollapse: 'collapse', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
        <thead style={{ backgroundColor: '#f8f8f8' }}>
        <tr>
          <th onClick={() => setSorting('id')} style={{ cursor: 'pointer', padding: '12px', border: '1px solid #ddd' }}>ID {getSortArrow('id')}</th>
          <th onClick={() => setSorting('name')} style={{ cursor: 'pointer', padding: '12px', border: '1px solid #ddd' }}>Name {getSortArrow('name')}</th>
          <th onClick={() => setSorting('email')} style={{ cursor: 'pointer', padding: '12px', border: '1px solid #ddd' }}>Email {getSortArrow('email')}</th>
          <th onClick={() => setSorting('role')} style={{ cursor: 'pointer', padding: '12px', border: '1px solid #ddd' }}>Role {getSortArrow('role')}</th>
          <th style={{ padding: '12px', border: '1px solid #ddd' }}>Actions</th>
        </tr>
        </thead>
        <tbody>
        {users.map(user => (
          <UserItem user={user} onDelete={() => handleDeleteUser(user)} onEdit={handleEditUser} key={user.id} />
        ))}
        </tbody>
      </table>

      <EditUserModal
        user={editingUser}
        open={!!editingUser}
        onClose={() => setEditingUser(null)}
        onSave={handleSaveEditUser}
      />

      {userToRemove && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.25)' }}>
            <p>Are you sure you want to remove {userToRemove.name}?</p>
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
              <button onClick={ () => removeUser(userToRemove.id) } style={{ cursor: 'pointer', marginRight: '10px', padding: '8px 16px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px' }}>
                Yes
              </button>
              <button onClick={() => setUserToRemove(null)} style={{ padding: '8px 16px', cursor: 'pointer', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px' }}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
